import React from "react";
import ctaImage from "../../assets/img/cta-new.svg";

const CallToAction = () => {
    return (
        <section className="ptb-60 primary-bg">
            <div className="container">
                <div className="row align-items-center justify-content-between">
                    <div className="col-md-7 col-lg-6">
                        <div className="cta-content-wrap text-white">
                            <h2 className="text-white">
                                Best Cloud Hosting <br /> With Trusted Service
                            </h2>
                            <p>
                                Objectively innovate high standards in methodologies vis-a-vis sustainable solutions. Compellingly architect front-end methods and streamline mission-critical information.
                            </p>
                        </div>
                        <div className="action-btns mt-4">
                            <a href="#" className="btn btn-tertiary">
                                Get Started Now
                            </a>
                        </div>
                    </div>
                    <div className="col-md-5 col-lg-4">
                        <div className="cta-img-wrap text-center">
                            <img src={ctaImage} className="img-fluid" alt="Server Room" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CallToAction;
